import { useState } from 'react';
import { parseQty } from '../utils/formatters';

export default function QtyInput({value,onChange,si,mn,t}){
  const[text,setText]=useState(null);
  const[err,setErr]=useState(false);
  const editing=text!==null;
  return<div style={{position:'relative',display:'inline-block'}}>
    <input type="text" inputMode="text"
      value={editing?text:value}
      onFocus={e=>{setText(String(value||''));setErr(false);e.target.select();}}
      onChange={e=>{setText(e.target.value);setErr(false);}}
      onBlur={()=>{const v=parseQty(text);if(v!==null){onChange(v);setErr(false);}else if(text.trim()===''){onChange('');setErr(false);}else{setErr(true);}setText(null);}}
      onKeyDown={e=>{if(e.key==='Enter')e.target.blur();}}
      name="qty-input" autoComplete="chrome-off" data-1p-ignore data-lpignore="true"
      style={{...si,width:55,padding:"3px",textAlign:"center",fontFamily:mn,fontSize:11,borderColor:err?t.ac:undefined}}/>
    {err&&<div style={{position:'absolute',top:'100%',left:0,whiteSpace:'nowrap',fontSize:8,color:t.ac,fontWeight:600,marginTop:1}}>invalid qty</div>}
  </div>;
}
